import React from "react";

import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "components/Table/EnhancedTable";
import makeData from "makeData";

const Dashboard = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "firstName"
      },
      {
        Header: "Last Name",
        accessor: "lastName"
      },
      {
        Header: "Application Number",
        accessor: "appNumber"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "Phone",
        accessor: "phone"
      },
      {
        Header: "Status",
        accessor: "status"
      }
    ],
    []
  );

  const [data, setData] = React.useState(React.useMemo(() => makeData(1), []));

  console.log(data); 
  /**
   * Data Returned
   * appNumber: "111"
    email: "email@me.com"
    firstName: "Olajide joshua"
    lastName: "Tomiwa"
    phone: "08136023230"
    status: "Not yet admitted"
    subRows: undefined
   */
  const [skipPageReset, setSkipPageReset] = React.useState(false);

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value
          };
        }
        return row;
      })
    );
  };

  return (
    <div>
      <CssBaseline />
      <EnhancedTable
        columns={columns}
        data={data}
        setData={setData}
        updateMyData={updateMyData}
        skipPageReset={skipPageReset}
      />
    </div>
  );
};

export default Dashboard;
